import socket from '../socketConfig'
import { useNotificationsStore } from '@/store/notifications'

const CONTEXT = 'notification'

export default {
  setupEventListeners() {
    socket.on(`${CONTEXT}:created`, this.onCreated)
  },

  removeEventListeners() {
    socket.off(`${CONTEXT}:created`, this.onCreated)
  },

  async onCreated() {
    try {
      const store = useNotificationsStore()
      await store.getNotifications()
    } catch {}
  },
}
